import selectLocalExercise from './selectLocalExercise';
const selectCompletionPaneVisible = (state, id) => {
  const localExercise = selectLocalExercise(state, id);
  if (localExercise === undefined) {
    return false;
  }
  return localExercise.completionPaneVisible;
};
export default selectCompletionPaneVisible;